const COMMERCIAL_PLATE_PENULTIMATE_LETTER = /^[XYZ]$/;

export const OTHER_VEHICLE_TYPES = [
  "Commercial Vehicle",
  "Motorcycle",
  "Tricycle",
  "Truck / Trailer",
];

export const PRIVATE_MOTOR_COMMERCIAL_WARNING =
  "Failure to process commercial vehicle with private motor type, please select other types: " +
  OTHER_VEHICLE_TYPES.join(", ");

export const hasCommercialPlateSuffix = (plateNumber) => {
  const normalizedPlate = String(plateNumber || "")
    .replace(/[^a-z0-9]/gi, "")
    .toUpperCase();

  return COMMERCIAL_PLATE_PENULTIMATE_LETTER.test(normalizedPlate.slice(-2, -1));
};

export const shouldBlockPrivateMotorPlate = ({
  insuranceType,
  product,
  plateNumber,
}) =>
  ["AG", "AGP", "FGI", "FGIP"].includes(insuranceType) &&
  (product?.id === 1 || product?.product_category === "PrivateMotor") &&
  hasCommercialPlateSuffix(plateNumber);
